<template>
  <div>
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">证书管理</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>证书绑定</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">项目信息</div>

      <div class="Schedule">
        <span class="stepInfo">1、插入UKey</span>
        <span class="intervel">>>></span>
        <span class="stepInfo">2、读取证书</span>
        <span class="intervel">>>></span>
        <span class="stepInfo">3、完成绑定</span>
      </div>
      <el-form class="rule-form" :inline-message="true">
        <el-form-item label="CA账号：">
          <el-select v-model="CertId">
            <el-option v-for="item in certs" :key="item.value" :label="item.text" :value="item.value" @click.native="fnPrint(item)"></el-option>
          </el-select>
          <el-button class="btn" @click="fnGetList()">读取证书</el-button>
        </el-form-item>
        <el-form-item label="USB-Key序列号">
          <label>{{ Ukey_ID }}</label>
        </el-form-item>
        <el-form-item v-if="IsBinding" label="USB-Key名称">
          <label v-if="IsBinding">{{ CACertOwner }}</label>
        </el-form-item>
        <el-form-item v-if="IsBinding" label="USB-Key唯一标识">
          <label v-if="IsBinding">{{ CartBandCode }}</label>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn_wrap">
      <span class="btn_1" @click.stop="fnBinding">绑定</span>
      <span class="btn_1" v-if="IsBinding" @click.stop="fnDisBinding">解除绑定</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certs: [],
      CertId: '',
      Ukey_ID: '',
      SupplierId: '',
      IsBinding: true,
      CartBandCode: '',
      CACertOwner: ''
    }
  },
  mounted() {
    window.init(
      function () {
        window.console.log('sucess')
      },
      function () {
        window.console.log('fail')
      }
    )

    this.getRequest('/Purchase/GetCABindingDetail').then((res) => {
      if (res.data.errcode == 0) {
        this.IsBinding = res.data.IsBinding
        this.CartBandCode = res.data.CartBandCode
        this.CACertOwner = res.data.CACertOwner
      } else {
        this.$message.error(res.data.errmsg)
      }
    })
  },
  methods: {
    fnPrint(item) {
      window.console.log(item)
      this.Ukey_ID = item.value
      this.CACertOwner = item.text
    },
    fnDisBinding() {
      this.$confirm('是否确认解除绑定', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let config = {
          params: {
            CartBandCode: '',
            BeginDate: '',
            EndDate: '',
            CACertOwner: ''
          }
        }

        this.getRequest('/Purchase/BindingCA', config).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('成功解除绑定!')
            setTimeout(() => {
              window.close()
            }, 2000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      })
    },
    fnBinding() {
      if (this.CertId == undefined || this.CertId == null) {
        this.$message.error('请选择有效CA UKey')
        return
      }
      window.SOF_ExportUserCert(this.CertId, (data) => {
        var usercert = data.retVal
        window.SOF_GetCertEntity(usercert, (data1) => {
          var CACode = data1.retVal

          var beginDate
          var endDate
          SOF_GetCertInfo(usercert, 11, (data2) => {
            beginDate = data2.retVal
            SOF_GetCertInfo(usercert, 12, (data3) => {
              endDate = data3.retVal

              let config = {
                params: {
                  CartBandCode: CACode,
                  BeginDate: beginDate,
                  EndDate: endDate,
                  CACertOwner: this.CACertOwner
                }
              }

              this.getRequest('/Purchase/BindingCA', config).then((res) => {
                if (res.data.errcode == 0) {
                  this.$message.success('成功绑定!')
                  setTimeout(() => {
                    window.close()
                  }, 2000)
                } else {
                  this.$message.error(res.data.errmsg)
                }
              })
            })
          })
        })
      })

      //TODO:调用后台获取当前密钥
    },
    fnGetList() {
      this.certs = []
      window.SOF_GetUserList((data) => {
        window.console.log(data)
        var UserListStr = data.retVal
        var arr = UserListStr.split('&&&')
        for (var index = 0; index < arr.length; index++) {
          if (arr[index] == '') continue
          var Belong = arr[index].split('||')[0] //电子合同个人测试6||998000100204344/5303201807021399(证书所有者||密码卡序列号/USB-key序列号)
          var u_key = arr[index].split('/')[1]
          var obj = {}
          obj.text = Belong
          obj.value = u_key
          this.certs.push(obj)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btn_wrap {
  width: 200px;
  margin: auto;
  padding: 50px 20px;
  .btn_1 {
    width: 50px;
    color: white;
    border-radius: 10px;
    cursor: pointer;
    background: #0774d7;
  }
}

.rule-form {
  .btn {
    padding: 0 20px;
    border-radius: 5px;
    border: 1px solid #2e83c9;
    color: #2e83c9;
    // height: 20px;
    // padding-top: 10px;
    // margin-top: 10px;
    margin-left: 20px;
  }
}
.change_inform {
  margin: center;
}

.Schedule {
  margin: 20px;
  text-align: center;
  font-weight: bold;
}

.intervel {
  padding: 20px 30px;
  margin: 20px;
  color: #0774d7;
}
.stepInfo {
  color: #0774d7;
}
.rule-form {
  width: 800px;
  margin: auto;
}
.rule-form ::v-deep .el-form-item {
  flex: 100%;
}
</style>